/**
 * CODE FOR THE PRODUCT CLIM CONFIGURATOR
 * @version 1.0.0
 * File include in the theme.liquid
 */

document.addEventListener("DOMContentLoaded", function () {
  /**
   * For open the cart drawer
   */

  async function openDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.removeAttribute("hidden");
      cartDrawer.show();
      document.body.classList.add("has-modal-open");
      document.body.style.overflow = "hidden";
    } else {
      console.error("Cart drawer element not found");
    }
  }

  async function closeCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.setAttribute("hidden", "true");
      document.body.classList.remove("has-modal-open", "has-modal-opening");
      document.body.style.overflow = "auto";
    } else {
      console.error("Cart drawer element not found");
    }
  }

  /**
   *Update the header cart count bubble
   * @param {number } itemCount
   */
  async function updateHeaderCountBubble(itemCount) {
    try {
      const cartCountBubble = document.querySelector("cart-count.count");
      if (cartCountBubble) {
        cartCountBubble.textContent = itemCount;
        cartCountBubble.removeAttribute("hidden");
      } else {
        console.error("Cart count bubble element not found");
      }
    } catch (error) {
      console.error("Error updating cart count bubble:", error);
    }
  }

  /**
   * Update the quantity of a cart item
   * @param {itemId}  The id of the item to update
   * @param {newQuantity} The new quantity of the item
   */
  async function updateCartItemQuantity(itemId, newQuantity) {
    try {
      const response = await fetch(`/cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemId,
          quantity: newQuantity,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const cart = await response.json();

      // Update the cart drawer and header count bubble
      await updateCartDrawer();
      await updateHeaderCountBubble(cart.item_count);
    } catch (error) {
      console.error("Error updating cart item quantity:", error);
    }
  }

  /**
   * Remove a cart item
   * @param {itemId} The id of the item to remove
   */
  async function removeCartItem(itemId) {
    try {
      const response = await fetch(`/cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemId,
          quantity: 0,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const cart = await response.json();

      // Update the cart drawer and header count bubble
      await updateCartDrawer();
      await updateHeaderCountBubble(cart.item_count);
    } catch (error) {
      console.error("Error removing cart item:", error);
    }
  }

  /**
   * Initialize cart drawer events
   * @returns
   */
  async function initializeCartDrawerEvents() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {
      // Close button event
      const closeButton = cartDrawer.querySelector(".drawer__close");
      if (closeButton) {
        closeButton.addEventListener("click", closeCartDrawer);
      }
      const overlay = cartDrawer.querySelector("overlay-element");
      if (overlay) {
        overlay.addEventListener("click", closeCartDrawer);
      }

      // Event for modifying or deleting a product
      const cartItems = cartDrawer.querySelectorAll(
        "cart-items .horizontal-product"
      );
      cartItems.forEach((item) => {
        const removeButton = item.querySelector('[is="cart-remove-button"]');

        if (removeButton) {
          removeButton.addEventListener("click", async (event) => {
            event.preventDefault();
            const itemId = removeButton.getAttribute("data-index");
            await removeCartItem(itemId);
          });
        }

        const quantityInput = item.querySelector(".quantity__input");
        if (quantityInput) {
          quantityInput.addEventListener("change", async (event) => {
            const itemId = quantityInput.getAttribute(
              "data-quantity-variant-id"
            );

            const newQuantity = quantityInput.value;
            await updateCartItemQuantity(itemId, newQuantity);
          });
        }
      });
    } else {
      console.error("Cart drawer element not found");
    }
  }

  /**
   * Update the cart drawer
   * @returns
   */
  async function updateCartDrawer() {
    try {
      const res = await fetch("/?section_id=cart-drawer");
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const text = await res.text();
      const html = document.createElement("div");
      html.innerHTML = text;

      const newBox = html.querySelector(".cart-drawer").innerHTML;
      const cartDrawer = document.querySelector(".cart-drawer");

      if (cartDrawer) {
        cartDrawer.innerHTML = newBox;

        // Initialize cart drawer events
        await initializeCartDrawerEvents();
      } else {
        console.error("Cart drawer element not found");
      }
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    }
  }

  /**
   *Update the cart contents
   * @returns
   */
  async function updateCartContents() {
    try {
      const response = await fetch("/cart.js", {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      const cartDrawer = document.querySelector(".cart-drawer");

      if (response.ok && cartDrawer) {
        const cart = await response.json();
        if (cart.items.length > 0) {
          initializeCartDrawerEvents();
          await updateCartDrawer();
        }
      } else {
        throw new Error("Failed to fetch cart contents");
      }
    } catch (error) {
      console.error("Error fetching cart contents:", error);
    }
  }

  /**
   * Function update cart drawer items
   * @returns
   */
  async function updateGlobalCartDrawer() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      await initializeCartDrawerEvents();
      await updateCartContents();
      await updateCartDrawer();
      await updateHeaderCountBubble(cart.item_count);

      await openDrawer();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  /**
   * Format a number as a currency
   * @param {number} cents
   * @param {string} format
   */
  formatMoney = function (cents, format = "") {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "GBP",
      currencyDisplay: "narrowSymbol",
    }).format(cents / 100);
  };

  /**
   *RETRIEVE THE CONTAINERS ON PRODUCT PAGE
   */
  var selectors = {
    //here we get the selectors for managing the configurator options
    container: "#MainProduct",

    //Mono
    climAndAccessoriesPriceArreaMono: ".climAndAccessoriesPriceArreaMono",
    climAndAccessoriesPriceArreaMonoBottom: ".priceLineClimAndAccessoriesMono",
    priceArea: ".product-price",
    ArreaWasPriceMonosplit: ".wasPriceLineMono",

    //Bi
    climAndAccessoriesPriceArreaBi: ".climAndAccessoriesPriceArreaBi",
    ArreaWasPriceBisplit: ".ArreaWasPriceBisplit",

    //Tripslit
    climAndAccessoriesPriceArreaTri: ".climAndAccessoriesPriceArreaTri",
    ArreaWasPriceTrisplit: ".ArreaWasPriceTrisplit",

    //Quadruplitsplit
    climAndAccessoriesPriceArreaQuad: ".climAndAccessoriesPriceArreaQuadri",
    ArreaWasPriceQuadrisplit: ".ArreaWasPriceQuadrisplit",

    //Readyclim
    readyClimVariantPriceArea: ".readyClimVariantPriceArea",
  };

  /**
   * INITIALISING THE PRICE OF AIR CONDITIONERS AND ACCESSORIES
   * UPDATE CONTAINER PRICE MONOSPLIT
   */
  function updateAccesoriesPriceMonoSplit(globalPrice, wasPrice) {
    var priceAreaClimAndAccessoriesMono = document.querySelector(
      selectors.climAndAccessoriesPriceArreaMono
    );

    // Old price management
    var priceAreaWasPriceMono = document.querySelector(
      selectors.ArreaWasPriceMonosplit
    );

    // Update the content of the elements with the prices
    if (priceAreaClimAndAccessoriesMono) {
      var newPriceAreaLineClimAndAccessories = document.createElement("div");
      var span = document.createElement("span");
      span.className = "priceLineClimAndAccessoriesMono";
      span.innerHTML = formatMoney(globalPrice);
      newPriceAreaLineClimAndAccessories.appendChild(span);
      priceAreaClimAndAccessoriesMono.innerHTML =
        newPriceAreaLineClimAndAccessories.innerHTML;
    } else {
      console.error("priceAreaClimAndAccessoriesMono not found");
    }

    if (priceAreaWasPriceMono) {
      var newPriceAreaLineWasPriceMono = document.createElement("div");
      var span = document.createElement("span");
      span.className = "wasPriceLineMono";
      span.innerHTML = formatMoney(wasPrice);
      newPriceAreaLineWasPriceMono.appendChild(span);
      priceAreaWasPriceMono.innerHTML = newPriceAreaLineWasPriceMono.innerHTML;
    } else {
      console.error("priceAreaWasPriceMono not found");
    }
  }

  /**
   * UPDATE PRICE MONOSPLIT
   */
  function updatePriceMonoSplit(
    variant2500,
    variant3400,
    variant5270,
    readyclim4,
    readyclimAutre4,
    readyclim6,
    readyclimAutre6,
    connecteur,
    connecteurAutre,
    moduleWifiProduct,
    serenityPack,
    annualMaintenance,
    premiumWarranty
  ) {
    const connecteurPrice = connecteur.price;
    const connecteurAutrePrice = connecteurAutre.price;
    const moduleWifiPrice = moduleWifiProduct.price;

    var climAndAccessoriesPrice = 0;

    var accessoriesPrice = 0;
    var accessoriesPrice5270 = 0;

    var comfortPackPrice = 0;

    var wasPriceClimAndAccessories = 0;

    //Mono clim selection
    var radiosClims = document.getElementsByName("watt-clim-mono");

    function updateClimPrice() {
      var climPrice = 0;

      for (var radio of radiosClims) {
        if (radio.checked) {
          if (radio.id == "mono-2500W") {
            climPrice = variant2500.price;
          } else if (radio.id == "mono-3400W") {
            climPrice = variant3400.price;
          } else if (radio.id == "mono-5270W") {
            climPrice = variant5270.price;
          }

          climAndAccessoriesPrice += climPrice;
        }
      }

      // Readyclim selection
      var idRcSelectMono = document.getElementsByName("rcSelect-Mono");

      for (var select of idRcSelectMono) {
        if (select.checked) {
          if (select.value == "4") {
            accessoriesPrice = readyclim4.price;
          } else if (select.value == "6") {
            accessoriesPrice = readyclim6.price;
          } else if (select.value == "8") {
            accessoriesPrice = readyclim4.price * 2 + connecteurPrice;
          } else if (select.value == "10") {
            accessoriesPrice =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.value == "12") {
            accessoriesPrice = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoriesPrice = 0;
          }

          climAndAccessoriesPrice += accessoriesPrice;
          wasPriceClimAndAccessories += accessoriesPrice;
        }
      }

      // Readyclim 5270 selection
      var idRcSelectMono5270 = document.getElementsByName("rcSelect-Mono-5270");

      for (var select of idRcSelectMono5270) {
        if (select.checked) {
          if (select.value == "4-5270") {
            accessoriesPrice5270 = readyclimAutre4.price;
          } else if (select.value == "6-5270") {
            accessoriesPrice5270 = readyclimAutre6.price;
          } else if (select.value == "8-5270") {
            accessoriesPrice5270 =
              readyclimAutre4.price * 2 + connecteurAutrePrice;
          } else if (select.value == "10-5270") {
            accessoriesPrice5270 =
              readyclimAutre4.price +
              readyclimAutre6.price +
              connecteurAutrePrice;
          } else if (select.value == "12-5270") {
            accessoriesPrice5270 =
              readyclimAutre6.price * 2 + connecteurAutrePrice;
          } else {
            accessoriesPrice5270 = 0;
          }

          climAndAccessoriesPrice += accessoriesPrice5270;
          wasPriceClimAndAccessories += accessoriesPrice5270;
        }
      }

      var wifiPrice = 0;

      // Wifi selection
      var idWifiMono = document.getElementsByName("wifiMono");

      for (var select of idWifiMono) {
        if (select.checked) {
          if (select.value == "mw1") {
            wifiPrice = moduleWifiPrice;
          } else {
            wifiPrice = 0;
          }

          climAndAccessoriesPrice += wifiPrice;
          wasPriceClimAndAccessories += wifiPrice;
        }
      }

      //Pack Comfort Selection
      var idComfortPack = document.getElementsByName("pack_confort_mono");

      for (var select of idComfortPack) {
        if (select.checked) {
          if (select.value == "pack_serenity_mono") {
            comfortPackPrice = serenityPack.price;
          } else if (select.value == "entretien_annuel_mono") {
            comfortPackPrice = annualMaintenance.price;
          } else if (select.value == "garantie_premium_mono") {
            comfortPackPrice = premiumWarranty.price;
          } else {
            comfortPackPrice = 0;
          }

          climAndAccessoriesPrice += comfortPackPrice;
          wasPriceClimAndAccessories += comfortPackPrice;
        }
      }

      var wasclimPrice = 0;
      var globalPrice = climAndAccessoriesPrice;

      //Old clim price management
      for (var radio of radiosClims) {
        if (radio.checked) {
          if (radio.id == "mono-2500W") {
            wasclimPrice = variant2500.compare_at_price;
          } else if (radio.id == "mono-3400W") {
            wasclimPrice = variant3400.compare_at_price;
          } else if (radio.id == "mono-5270W") {
            wasclimPrice = variant5270.compare_at_price;
          }
          wasPriceClimAndAccessories += wasclimPrice;
        }
      }

      console.log(
        "_ clim Mono : " +
          climPrice +
          "_ Ready Mono : " +
          accessoriesPrice +
          "_ Ready Mono 5270 : " +
          accessoriesPrice5270 +
          "_ wifiMono : " +
          wifiPrice +
          "_ global price mono: " +
          globalPrice +
          "_ Comfort pack price : " +
          comfortPackPrice +
          " _ was clim price : " +
          wasclimPrice
      );

      // MAJ Container price
      updateAccesoriesPriceMonoSplit(globalPrice, wasPriceClimAndAccessories);

      climAndAccessoriesPrice = 0;
      wasPriceClimAndAccessories = 0;
    }

    for (var radio of radiosClims) {
      radio.addEventListener("change", updateClimPrice);
    }

    var rcSelectMonoElements = document.getElementsByName("rcSelect-Mono");
    for (var element of rcSelectMonoElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rcSelectMono5270Elements =
      document.getElementsByName("rcSelect-Mono-5270");
    for (var element of rcSelectMono5270Elements) {
      element.addEventListener("click", updateClimPrice);
    }

    var wifiMonoElements = document.getElementsByName("wifiMono");
    for (var element of wifiMonoElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var packComfortMonoElements =
      document.getElementsByName("pack_confort_mono");
    for (var element of packComfortMonoElements) {
      element.addEventListener("click", updateClimPrice);
    }

    updateClimPrice();
  }

  /**
   * UPDATE CONTAINER PRICE BISPLIT
   * @param {number} globalPrice
   * @param {number} wasPrice
   */
  function updateAccesoriesPriceBiSplit(globalPrice, wasPrice) {
    var priceAreaClimAndAccessoriesBi = document.querySelector(
      selectors.climAndAccessoriesPriceArreaBi
    );

    var priceAreaWasPriceBi = document.querySelector(
      selectors.ArreaWasPriceBisplit
    );

    if (priceAreaClimAndAccessoriesBi) {
      var newPriceAreaLineClimAndAccessories = document.createElement("div");
      var span = document.createElement("span");
      span.className = "priceLineClimAndAccessoriesBi";
      span.innerHTML = formatMoney(globalPrice);
      newPriceAreaLineClimAndAccessories.appendChild(span);
      priceAreaClimAndAccessoriesBi.innerHTML =
        newPriceAreaLineClimAndAccessories.innerHTML;
    } else {
      console.error("priceAreaClimAndAccessoriesBi not found");
    }

    if (priceAreaWasPriceBi) {
      var newPriceAreaLineWasPriceBi = document.createElement("div");
      var span = document.createElement("span");
      span.className = "wasPriceLineBi";
      span.innerHTML = formatMoney(wasPrice);
      newPriceAreaLineWasPriceBi.appendChild(span);
      priceAreaWasPriceBi.innerHTML = newPriceAreaLineWasPriceBi.innerHTML;
    } else {
      console.error("priceAreaWasPriceBi not found");
    }
  }

  /**
   *UPDATE PRICE BISPLIT
   */
  function updatePriceBiSplit(
    variant2600,
    variant3400,
    readyclim4,
    readyclim6,
    connecteur,
    moduleWifiProduct,
    serenityPack,
    annualMaintenance,
    premiumWarranty
  ) {
    const connecteurPrice = connecteur.price;
    const moduleWifiPrice = moduleWifiProduct.price;

    var climAndAccessoriesPrice = 0;
    var accessoriesPrice = 0;
    var accessoires2Price = 0;
    var wifiPrice = 0;
    var wasclimPrice = 0;
    var comfortPackPrice = 0;
    var wasPriceClimAndAccessories = 0;

    var radiosClimsBi = document.getElementsByName("watt-clim-bi");

    function updateClimPrice() {
      var climPrice = 0;

      for (var radio of radiosClimsBi) {
        if (radio.checked) {
          if (radio.id == "bi-2600W-2600W") {
            climPrice = variant2600.price;
          } else if (radio.id == "bi-2600W-3400W") {
            climPrice = variant3400.price;
          }

          climAndAccessoriesPrice += climPrice;
        }
      }

      // Ready clim 1 selection
      var idRc1Select = document.getElementsByName("rc1Select");

      for (var select of idRc1Select) {
        if (select.checked) {
          if (select.id == "rc1-4") {
            accessoriesPrice = readyclim4.price;
          } else if (select.id == "rc1-6") {
            accessoriesPrice = readyclim6.price;
          } else if (select.id == "rc1-8") {
            accessoriesPrice = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc1-10") {
            accessoriesPrice =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc1-12") {
            accessoriesPrice = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoriesPrice = 0;
          }

          climAndAccessoriesPrice += accessoriesPrice;
          wasPriceClimAndAccessories += accessoriesPrice;
        }
      }

      //Ready clim 2 selection
      var idRc2Select = document.getElementsByName("rc2Select");

      for (var select of idRc2Select) {
        if (select.checked) {
          if (select.id == "rc2-4") {
            accessoires2Price = readyclim4.price;
          } else if (select.id == "rc2-6") {
            accessoires2Price = readyclim6.price;
          } else if (select.id == "rc2-8") {
            accessoires2Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc2-10") {
            accessoires2Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc2-12") {
            accessoires2Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoires2Price = 0;
          }

          climAndAccessoriesPrice += accessoires2Price;
          wasPriceClimAndAccessories += accessoires2Price;
        }
      }

      //Wifi selection
      var mwSelect = document.getElementsByName("mwSelect");

      for (var select of mwSelect) {
        if (select.checked) {
          if (select.id == "mw1_bi") {
            wifiPrice = moduleWifiPrice;
          } else if (select.id == "mw2_bi") {
            wifiPrice = moduleWifiPrice * 2;
          } else {
            wifiPrice = 0;
          }

          climAndAccessoriesPrice += wifiPrice;
          wasPriceClimAndAccessories += wifiPrice;
        }
      }

      //Comfort pack selection
      var idComfortPack = document.getElementsByName("pack_confort_bi");

      for (var select of idComfortPack) {
        if (select.checked) {
          if (select.value == "pack_serenity_bi") {
            comfortPackPrice = serenityPack.price;
          } else if (select.value == "entretien_annuel_bi") {
            comfortPackPrice = annualMaintenance.price;
          } else if (select.value == "garantie_premium_bi") {
            comfortPackPrice = premiumWarranty.price;
          } else {
            comfortPackPrice = 0;
          }

          climAndAccessoriesPrice += comfortPackPrice;
          wasPriceClimAndAccessories += comfortPackPrice;
        }
      }

      var globalPrice = climAndAccessoriesPrice;

      for (var radio of radiosClimsBi) {
        if (radio.checked) {
          if (radio.id == "bi-2600W-2600W") {
            wasclimPrice = variant2600.compare_at_price;
          } else if (radio.id == "bi-2600W-3400W") {
            wasclimPrice = variant3400.compare_at_price;
          }
          wasPriceClimAndAccessories += wasclimPrice;
        }
      }

      console.log(
        "_ clim bi : " +
          climPrice +
          "_ Ready bi 1: " +
          accessoriesPrice +
          "_ Ready bi 2: " +
          accessoires2Price +
          "_ wifiBi : " +
          wifiPrice +
          "_ global price bi: " +
          globalPrice +
          "_ Was global price  bi : " +
          wasPriceClimAndAccessories +
          "_ Comfort pack price : " +
          comfortPackPrice +
          " _ was clim price : " +
          wasclimPrice
      );

      updateAccesoriesPriceBiSplit(globalPrice, wasPriceClimAndAccessories);

      climAndAccessoriesPrice = 0;
      wasPriceClimAndAccessories = 0;
    }

    for (var radio of radiosClimsBi) {
      radio.addEventListener("change", updateClimPrice);
    }

    var rc1SelectElements = document.getElementsByName("rc1Select");
    for (var element of rc1SelectElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rc2SelectElements = document.getElementsByName("rc2Select");
    for (var element of rc2SelectElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var mwSelectElements = document.getElementsByName("mwSelect");
    for (var element of mwSelectElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var packComfortBiElements = document.getElementsByName("pack_confort_bi");
    for (var element of packComfortBiElements) {
      element.addEventListener("click", updateClimPrice);
    }

    updateClimPrice();
  }

  /**
   * UPDATE CONTAINER PRICE TRISPLIT
   */
  function updateAccesoriesPriceTriSplit(globalPrice, wasPrice) {
    var priceAreaClimAndAccessoriesTri = document.querySelector(
      selectors.climAndAccessoriesPriceArreaTri
    );

    var priceAreaWasPriceTri = document.querySelector(
      selectors.ArreaWasPriceTrisplit
    );

    if (priceAreaClimAndAccessoriesTri) {
      var newPriceAreaLineClimAndAccessories = document.createElement("div");
      var span = document.createElement("span");
      span.className = "priceLineClimAndAccessoriesTri";
      span.innerHTML = formatMoney(globalPrice);
      newPriceAreaLineClimAndAccessories.appendChild(span);
      priceAreaClimAndAccessoriesTri.innerHTML =
        newPriceAreaLineClimAndAccessories.innerHTML;
    } else {
      console.error("priceAreaClimAndAccessoriesTri not found");
    }

    if (priceAreaWasPriceTri) {
      var newPriceAreaLineWasPriceTri = document.createElement("div");
      var span = document.createElement("span");
      span.className = "wasPriceLineTri";
      span.innerHTML = formatMoney(wasPrice);
      newPriceAreaLineWasPriceTri.appendChild(span);
      priceAreaWasPriceTri.innerHTML = newPriceAreaLineWasPriceTri.innerHTML;
    } else {
      console.error("priceAreaWasPriceTri not found");
    }
  }

  /**
   *UPDATE PRICE TRISPLIT
   */
  function updatePriceTrisplit(
    variant2600_2600_3500,
    readyclim4,
    readyclim6,
    connecteur,
    moduleWifiProduct,
    serenityPack,
    annualMaintenance,
    premiumWarranty
  ) {
    const connecteurPrice = connecteur.price;
    const moduleWifiPrice = moduleWifiProduct.price;

    var climAndAccessoriesPrice = 0;
    var wasPriceClimAndAccessories = 0;
    var wasclimPrice = 0;
    var accessories1Price = 0;
    var accessoires2Price = 0;
    var accessoires3Price = 0;
    var wifiPrice = 0;
    var comfortPackPrice = 0;

    var radiosClimsTri = document.getElementsByName("watt-clim-tri");

    function updateClimPrice() {
      var climPrice = 0;

      //Clim selection tri
      for (var radio of radiosClimsTri) {
        if (radio.checked) {
          if (radio.id == "tri-2600W-2600W-2600W") {
            climPrice = variant2600_2600_3500.price;
          }

          climAndAccessoriesPrice += climPrice;
        }
      }

      //Readyclim 1 selection
      var idRc1SelectTri = document.getElementsByName("rc1Select-trisplit");

      for (var select of idRc1SelectTri) {
        if (select.checked) {
          if (select.id == "rc1-4-tri") {
            accessories1Price = readyclim4.price;
          } else if (select.id == "rc1-6-tri") {
            accessories1Price = readyclim6.price;
          } else if (select.id == "rc1-8-tri") {
            accessories1Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc1-10-tri") {
            accessories1Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc1-12-tri") {
            accessories1Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessories1Price = 0;
          }

          climAndAccessoriesPrice += accessories1Price;
          wasPriceClimAndAccessories += accessories1Price;
        }
      }

      //Readyclim 2 selection
      var idRc2SelectTri = document.getElementsByName("rc2Select-trisplit");

      for (var select of idRc2SelectTri) {
        if (select.checked) {
          if (select.id == "rc2-4-tri") {
            accessoires2Price = readyclim4.price;
          } else if (select.id == "rc2-6-tri") {
            accessoires2Price = readyclim6.price;
          } else if (select.id == "rc2-8-tri") {
            accessoires2Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc2-10-tri") {
            accessoires2Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc2-12-tri") {
            accessoires2Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoires2Price = 0;
          }

          climAndAccessoriesPrice += accessoires2Price;
          wasPriceClimAndAccessories += accessoires2Price;
        }
      }

      //Readyclim 3 selection
      var idRc3SelectTri = document.getElementsByName("rc3Select-trisplit");

      for (var select of idRc3SelectTri) {
        if (select.checked) {
          if (select.id == "rc3-4-tri") {
            accessoires3Price = readyclim4.price;
          } else if (select.id == "rc3-6-tri") {
            accessoires3Price = readyclim6.price;
          } else if (select.id == "rc3-8-tri") {
            accessoires3Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc3-10-tri") {
            accessoires3Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc3-12-tri") {
            accessoires3Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoires3Price = 0;
          }

          climAndAccessoriesPrice += accessoires3Price;
          wasPriceClimAndAccessories += accessoires3Price;
        }
      }

      //Wifi selection
      var mwSelectTri = document.getElementsByName("mwSelect-trisplit");

      for (var select of mwSelectTri) {
        if (select.checked) {
          if (select.id == "mw1_tri") {
            wifiPrice = moduleWifiPrice;
          } else if (select.id == "mw2_tri") {
            wifiPrice = moduleWifiPrice * 2;
          } else if (select.id == "mw3_tri") {
            wifiPrice = moduleWifiPrice * 3;
          } else {
            wifiPrice = 0;
          }

          climAndAccessoriesPrice += wifiPrice;
          wasPriceClimAndAccessories += wifiPrice;
        }
      }

      //Comfort pack selection
      var idComfortPack = document.getElementsByName("pack_confort_tri");

      for (var select of idComfortPack) {
        if (select.checked) {
          if (select.value == "pack_serenity_tri") {
            comfortPackPrice = serenityPack.price;
          } else if (select.value == "entretien_annuel_tri") {
            comfortPackPrice = annualMaintenance.price;
          } else if (select.value == "garantie_premium_tri") {
            comfortPackPrice = premiumWarranty.price;
          } else {
            comfortPackPrice = 0;
          }

          climAndAccessoriesPrice += comfortPackPrice;
          wasPriceClimAndAccessories += comfortPackPrice;
        }
      }

      //Global Price
      var globalPrice = climAndAccessoriesPrice;

      for (var radio of radiosClimsTri) {
        if (radio.checked) {
          if (radio.id == "tri-2600W-2600W-2600W") {
            wasclimPrice = variant2600_2600_3500.compare_at_price;
          }
          wasPriceClimAndAccessories += wasclimPrice;
        }
      }

      // console.log(
      //   "_ clim tri : " +
      //     climPrice +
      //     "_ Ready tri 1: " +
      //     accessories1Price +
      //     "_ Ready tri 2: " +
      //     accessoires2Price +
      //     "_ Ready tri 3: " +
      //     accessoires3Price +
      //     "_ wifiTri : " +
      //     wifiPrice +
      //     "_ global price tri: " +
      //     globalPrice +
      //     "_ Comfort pack price : " +
      //     comfortPackPrice +
      //     " _ was clim price : " +
      //     wasclimPrice
      // );

      // MAJ container price
      updateAccesoriesPriceTriSplit(globalPrice, wasPriceClimAndAccessories);

      climAndAccessoriesPrice = 0;
      wasPriceClimAndAccessories = 0;
    }

    for (var radio of radiosClimsTri) {
      radio.addEventListener("change", updateClimPrice);
    }

    var rc1SelectTriElements = document.getElementsByName("rc1Select-trisplit");
    for (var element of rc1SelectTriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rc2SelectTriElements = document.getElementsByName("rc2Select-trisplit");
    for (var element of rc2SelectTriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rc3SelectTriElements = document.getElementsByName("rc3Select-trisplit");
    for (var element of rc3SelectTriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var mwSelectTriElements = document.getElementsByName("mwSelect-trisplit");
    for (var element of mwSelectTriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var packComfortTriElements = document.getElementsByName("pack_confort_tri");
    for (var element of packComfortTriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    updateClimPrice();
  }

  /**
   * UPDATE CONTAINER PRICE QUADRISPLIT
   */
  function updateAccesoriesPriceQuadriSplit(globalPrice, wasPrice) {
    var priceAreaClimAndAccessoriesQuad = document.querySelector(
      selectors.climAndAccessoriesPriceArreaQuad
    );

    var priceAreaWasPriceQuad = document.querySelector(
      selectors.ArreaWasPriceQuadrisplit
    );

    if (priceAreaClimAndAccessoriesQuad) {
      var newPriceAreaLineClimAndAccessories = document.createElement("div");
      var span = document.createElement("span");
      span.className = "priceLineClimAndAccessoriesQuadri";
      span.innerHTML = formatMoney(globalPrice);
      newPriceAreaLineClimAndAccessories.appendChild(span);
      priceAreaClimAndAccessoriesQuad.innerHTML =
        newPriceAreaLineClimAndAccessories.innerHTML;
    } else {
      console.error("priceAreaClimAndAccessoriesQuad not found");
    }

    if (priceAreaWasPriceQuad) {
      var newPriceAreaLineWasPriceQuad = document.createElement("div");
      var span = document.createElement("span");
      span.className = "wasPriceLineQuadri";
      span.innerHTML = formatMoney(wasPrice);
      newPriceAreaLineWasPriceQuad.appendChild(span);
      priceAreaWasPriceQuad.innerHTML = newPriceAreaLineWasPriceQuad.innerHTML;
    } else {
      console.error("priceAreaWasPriceQuad not found");
    }
  }

  /**
   * UPDATE PRICE QUADRISPLIT
   */
  function updatePriceQuadriSplit(
    variant2600_2600_2600_3500,
    readyclim4,
    readyclim6,
    connecteur,
    moduleWifiProduct,
    serenityPack,
    annualMaintenance,
    premiumWarranty
  ) {
    const connecteurPrice = connecteur.price;
    const moduleWifiPrice = moduleWifiProduct.price;

    var climAndAccessoriesPrice = 0;
    var wasPriceClimAndAccessories = 0;
    var wasclimPrice = 0;
    var accessories1Price = 0;
    var accessoires2Price = 0;
    var accessoires3Price = 0;
    var accessoires4Price = 0;
    var wifiPrice = 0;
    var comfortPackPrice = 0;

    var radiosClimsQuadri = document.getElementsByName("watt-clim-quadri");

    function updateClimPrice() {
      var climPrice = 0;

      //Clim quadri
      for (var radio of radiosClimsQuadri) {
        if (radio.checked) {
          if (radio.id == "quadri-2600W-2600W-2600W-2600W") {
            climPrice = variant2600_2600_2600_3500.price;
          }

          climAndAccessoriesPrice += climPrice;
        }
      }

      //Readyclim 1 selection
      var idRc1SelectQuadri = document.getElementsByName(
        "rc1Select-quadrisplit"
      );

      for (var select of idRc1SelectQuadri) {
        if (select.checked) {
          if (select.id == "rc1-4-quadri") {
            accessories1Price = readyclim4.price;
          } else if (select.id == "rc1-6-quadri") {
            accessories1Price = readyclim6.price;
          } else if (select.id == "rc1-8-quadri") {
            accessories1Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc1-10-quadri") {
            accessories1Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc1-12-quadri") {
            accessories1Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessories1Price = 0;
          }

          climAndAccessoriesPrice += accessories1Price;
          wasPriceClimAndAccessories += accessories1Price;
        }
      }

      //Readyclim 2 selection
      var idRc2Select = document.getElementsByName("rc2Select-quadrisplit");

      for (var select of idRc2Select) {
        if (select.checked) {
          if (select.id == "rc2-4-quadri") {
            accessoires2Price = readyclim4.price;
          } else if (select.id == "rc2-6-quadri") {
            accessoires2Price = readyclim6.price;
          } else if (select.id == "rc2-8-quadri") {
            accessoires2Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc2-10-quadri") {
            accessoires2Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc2-12-quadri") {
            accessoires2Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoires2Price = 0;
          }

          climAndAccessoriesPrice += accessoires2Price;
          wasPriceClimAndAccessories += accessoires2Price;
        }
      }

      //Readyclim 3 selection
      var idRc3Select = document.getElementsByName("rc3Select-quadrisplit");

      for (var select of idRc3Select) {
        if (select.checked) {
          if (select.id == "rc3-4-quadri") {
            accessoires3Price = readyclim4.price;
          } else if (select.id == "rc3-6-quadri") {
            accessoires3Price = readyclim6.price;
          } else if (select.id == "rc3-8-quadri") {
            accessoires3Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc3-10-quadri") {
            accessoires3Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc3-12-quadri") {
            accessoires3Price = readyclim6.price * 2 + connecteurPrice;
          }

          climAndAccessoriesPrice += accessoires3Price;
          wasPriceClimAndAccessories += accessoires3Price;
        } else {
          accessoires3Price = 0;
        }
      }

      //Readyclim 4 selection
      var idRc4Select = document.getElementsByName("rc4Select-quadrisplit");

      for (var select of idRc4Select) {
        if (select.checked) {
          if (select.id == "rc4-4-quadri") {
            accessoires4Price = readyclim4.price;
          } else if (select.id == "rc4-6-quadri") {
            accessoires4Price = readyclim6.price;
          } else if (select.id == "rc4-8-quadri") {
            accessoires4Price = readyclim4.price * 2 + connecteurPrice;
          } else if (select.id == "rc4-10-quadri") {
            accessoires4Price =
              readyclim4.price + readyclim6.price + connecteurPrice;
          } else if (select.id == "rc4-12-quadri") {
            accessoires4Price = readyclim6.price * 2 + connecteurPrice;
          } else {
            accessoires4Price = 0;
          }

          climAndAccessoriesPrice += accessoires4Price;
          wasPriceClimAndAccessories += accessoires4Price;
        }
      }

      //Wifi selection
      var mwSelectQuadri = document.getElementsByName("mwSelect-quadrisplit");

      for (var select of mwSelectQuadri) {
        if (select.checked) {
          if (select.id == "mw1_quadri") {
            wifiPrice = moduleWifiPrice;
          } else if (select.id == "mw2_quadri") {
            wifiPrice = moduleWifiPrice * 2;
          } else if (select.id == "mw3_quadri") {
            wifiPrice = moduleWifiPrice * 3;
          } else if (select.id == "mw4_quadri") {
            wifiPrice = moduleWifiPrice * 4;
          } else {
            wifiPrice = 0;
          }

          climAndAccessoriesPrice += wifiPrice;
          wasPriceClimAndAccessories += wifiPrice;
        }
      }

      //Comfort pack selection
      var idComfortPack = document.getElementsByName("pack_confort_quadri");

      for (var select of idComfortPack) {
        if (select.checked) {
          if (select.value == "pack_serenity_quadri") {
            comfortPackPrice = serenityPack.price;
          } else if (select.value == "entretien_annuel_quadri") {
            comfortPackPrice = annualMaintenance.price;
          } else if (select.value == "garantie_premium_quadri") {
            comfortPackPrice = premiumWarranty.price;
          } else {
            comfortPackPrice = 0;
          }

          climAndAccessoriesPrice += comfortPackPrice;
          wasPriceClimAndAccessories += comfortPackPrice;
        }
      }

      //Global price
      var globalPrice = climAndAccessoriesPrice;

      // Old clim price management
      for (var radio of radiosClimsQuadri) {
        if (radio.checked) {
          if (radio.id == "quadri-2600W-2600W-2600W-2600W") {
            wasclimPrice = variant2600_2600_2600_3500.compare_at_price;
          }
          wasPriceClimAndAccessories += wasclimPrice;
        }
      }

      // console.log(
      //   "_ clim quadri : " +
      //     climPrice +
      //     "_ Ready quadri 1: " +
      //     accessories1Price +
      //     "_ Ready quadri 2: " +
      //     accessoires2Price +
      //     "_ Ready quadri 3: " +
      //     accessoires3Price +
      //     "_ Ready quadri 4: " +
      //     accessoires4Price +
      //     "_ wifiQuadri : " +
      //     wifiPrice +
      //     "_ Comfort pack price : " +
      //     comfortPackPrice +
      //     "_ global price quadri: " +
      //     globalPrice +
      //     "_ Was global price  quadri : " +
      //     wasPriceClimAndAccessories
      // );

      // MAJ container price
      updateAccesoriesPriceQuadriSplit(globalPrice, wasPriceClimAndAccessories);

      climAndAccessoriesPrice = 0;
      wasPriceClimAndAccessories = 0;
    }

    for (var radio of radiosClimsQuadri) {
      radio.addEventListener("change", updateClimPrice);
    }

    var rc1SelectQuadriElements = document.getElementsByName(
      "rc1Select-quadrisplit"
    );
    for (var element of rc1SelectQuadriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rc2SelectQuadriElements = document.getElementsByName(
      "rc2Select-quadrisplit"
    );
    for (var element of rc2SelectQuadriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rc3SelectQuadriElements = document.getElementsByName(
      "rc3Select-quadrisplit"
    );
    for (var element of rc3SelectQuadriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var rc4SelectQuadriElements = document.getElementsByName(
      "rc4Select-quadrisplit"
    );
    for (var element of rc4SelectQuadriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var mwSelectQuadriElements = document.getElementsByName(
      "mwSelect-quadrisplit"
    );
    for (var element of mwSelectQuadriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    var packComfortQuadriElements = document.getElementsByName(
      "pack_confort_quadri"
    );
    for (var element of packComfortQuadriElements) {
      element.addEventListener("click", updateClimPrice);
    }

    updateClimPrice();
  }

  /**
   * RETRIEVE  PRODUCTS FETCHED FROM SHOPIFY
   */
  var climMonoProduct = {};
  var climBiProduct = {};
  var climTriProduct = {};

  //Check if the url of the product page contains tonair clim and if so, fetch the tonair products

  // if (
  //   window.location.href.indexOf("climatiseur-reversible-tonair") > -1 ||
  //   window.location.href.indexOf("climatiseur-bisplit-reversible-tonair") >
  //     -1 ||
  //   window.location.href.indexOf("tonair-climatiseur-reversible-trisplit") > -1
  // ) {
  //   $.ajax({
  //     url:
  //       window.Shopify.routes.root +
  //       "products/climatiseur-reversible-tonair-2500w-8500btu-wifi-ready-monosplit.js",
  //     async: false,
  //     dataType: "json",
  //     success: function (data) {
  //       climMonoProduct = data.variants;
  //     },
  //   });

  //   $.ajax({
  //     url:
  //       window.Shopify.routes.root +
  //       "products/climatiseur-bisplit-reversible-tonair-2500w-2500w-9000-9000btu-wifi-ready-monosplit.js",
  //     async: false,
  //     dataType: "json",
  //     success: function (data) {
  //       climBiProduct = data.variants;
  //     },
  //   });

  //   $.ajax({
  //     url:
  //       window.Shopify.routes.root +
  //       "products/tonair-climatiseur-reversible-trisplit-pompe-a-chaleur-air-air-pac.js",
  //     async: false,
  //     dataType: "json",
  //     success: function (data) {
  //       climTriProduct = data.variants;
  //     },
  //   });
  // } else {
  // $.ajax({
  //   url: window.Shopify.routes.root + "products/climatiseur-fixe-reversible.js",
  //   async: false,
  //   dataType: "json",
  //   success: function (data) {
  //     climMonoProduct = data.variants;
  //   },
  // });

  const productSlug = window.Shopify.routes.root.includes("/fr")
    ? "climatiseur-fixe-reversible"
    : "wall-mounted-air-conditioner-heat-pump";

  $.ajax({
    url: `${window.Shopify.routes.root}products/${productSlug}.js`,
    async: false,
    dataType: "json",
    success: function (data) {
      climMonoProduct = data.variants;
    },
  });

  $.ajax({
    url:
      window.Shopify.routes.root +
      "products/pompe-a-chaleur-climatiseur-bisplit.js",
    async: false,
    dataType: "json",
    success: function (data) {
      climBiProduct = data.variants;
    },
  });

  $.ajax({
    url:
      window.Shopify.routes.root +
      "products/climatiseur-trisplit-reversible-2600w-2600w-3500w-30m-30m-40m.js",
    async: false,
    dataType: "json",
    success: function (data) {
      climTriProduct = data.variants;
    },
  });
  // }

  var climQuadriProduct = {};
  $.ajax({
    url:
      window.Shopify.routes.root +
      "products/climatiseur-reversible-quadrisplit-x4-pompe-a-chaleur-air-air-pac.js",
    async: false,
    dataType: "json",
    success: function (data) {
      climQuadriProduct = data.variants;
    },
  });

  var readyclimProduct = {};
  $.ajax({
    url: window.Shopify.routes.root + "products/liaison-ready-clim.js",
    async: false,
    dataType: "json",
    success: function (data) {
      readyclimProduct = data.variants;
    },
  });

  var connecteurProduct = {};
  $.ajax({
    url:
      window.Shopify.routes.root +
      "products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8.js",
    async: false,
    dataType: "json",
    success: function (data) {
      connecteurProduct = data.variants;
    },
  });

  var connecteur = connecteurProduct[0];
  var connecteurAutre = connecteurProduct[1];

  var moduleWifiProduct = {};
  $.ajax({
    url:
      window.Shopify.routes.root +
      "products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready.js",
    async: false,
    dataType: "json",
    success: function (data) {
      moduleWifiProduct = data.variants[0];
    },
  });

  var serenityPack = {};
  $.ajax({
    url: window.Shopify.routes.root + "products/pack-serenite-1.js",
    async: false,
    dataType: "json",
    success: function (data) {
      serenityPack = data.variants;
    },
  });

  var annualMaintenance = {};
  $.ajax({
    url: window.Shopify.routes.root + "products/contrat-entretien-annuel.js",
    async: false,
    dataType: "json",
    success: function (data) {
      annualMaintenance = data.variants;
    },
  });

  var premiumWarranty = {};
  $.ajax({
    url: window.Shopify.routes.root + "products/garantie-premium-annuelle.js",
    async: false,
    dataType: "json",
    success: function (data) {
      premiumWarranty = data.variants[0];
    },
  });

  console.log("climMonoProduct test: ", climMonoProduct);
  console.log("climBiProduct: ", climBiProduct);
  console.log("climTriProduct: ", climTriProduct);
  console.log("climQuadriProduct: ", climQuadriProduct);
  console.log("readyclimProduct: ", readyclimProduct);
  console.log("connecteurProduct: ", connecteurProduct);
  console.log("moduleWifiProduct: ", moduleWifiProduct);
  console.log("serenityPack: ", serenityPack);
  console.log("annualMaintenance: ", annualMaintenance);
  console.log("premiumWarranty: ", premiumWarranty);

  var climMono1 = climMonoProduct[0];
  var climMono2 = climMonoProduct[1];
  var climMono3 = climMonoProduct[2];

  var climBi1 = climBiProduct[0];
  var climBi2 = climBiProduct[1];

  var climTri1 = climTriProduct[0];

  var climQuadri1 = climQuadriProduct[0];

  var readyclim4 = readyclimProduct[0];
  var readyclimAutre4 = readyclimProduct[1];
  var readyclim6 = readyclimProduct[2];
  var readyclimAutre6 = readyclimProduct[3];

  var serenityPackMono = serenityPack[0];
  var serenityPackBi = serenityPack[1];
  var serenityPackTri = serenityPack[2];
  var serenityPackQuadri = serenityPack[3];

  var annualMaintenanceMono = annualMaintenance[0];
  var annualMaintenanceBi = annualMaintenance[1];
  var annualMaintenanceTri = annualMaintenance[2];
  var annualMaintenanceQuadri = annualMaintenance[3];

  /**
   * Initialisation updated according to the air conditioner selected
   */

  //**Default split chécked management based on product url

  var url = window.location.href;
  if (url.indexOf("climatiseur-fixe-reversible") != -1) {
    document.querySelector('[value="split-mono"]').click();
  } else if (url.indexOf("bisplit") != -1) {
    document.querySelector('[value="split-bi"]').click();
  } else if (url.indexOf("trisplit") != -1) {
    document.querySelector('[value="split-tri"]').click();
  } else if (url.indexOf("quadrisplit") != -1) {
    document.querySelector('[value="split-quadri"]').click();
  }

  var mono2500W = document.getElementById("mono-2500W");
  if (mono2500W && mono2500W.checked) {
    updatePriceMonoSplit(
      climMono1,
      climMono2,
      climMono3,
      readyclim4,
      readyclimAutre4,
      readyclim6,
      readyclimAutre6,
      connecteur,
      connecteurAutre,
      moduleWifiProduct,
      serenityPackMono,
      annualMaintenanceMono,
      premiumWarranty
    );
  }

  function attachCheckedHandlerMono(elementId) {
    var element = document.getElementById(elementId);
    if (element) {
      element.onclick = function () {
        updatePriceMonoSplit(
          climMono1,
          climMono2,
          climMono3,
          readyclim4,
          readyclimAutre4,
          readyclim6,
          readyclimAutre6,
          connecteur,
          connecteurAutre,
          moduleWifiProduct,
          serenityPackMono,
          annualMaintenanceMono,
          premiumWarranty
        );
      };
    } else {
      console.error(`Element with ID ${elementId} not found`);
    }
  }

  function attachClickHandlerMono(elementName) {
    var elements = document.getElementsByName(elementName);
    for (var element of elements) {
      element.addEventListener("click", function () {
        updatePriceMonoSplit(
          climMono1,
          climMono2,
          climMono3,
          readyclim4,
          readyclimAutre4,
          readyclim6,
          readyclimAutre6,
          connecteur,
          connecteurAutre,
          moduleWifiProduct,
          serenityPackMono,
          annualMaintenanceMono,
          premiumWarranty
        );
      });
    }
  }

  attachCheckedHandlerMono("selectorTable");
  attachClickHandlerMono("rcSelect-Mono");
  attachClickHandlerMono("rcSelect-Mono-5270");
  attachClickHandlerMono("wifiMono");
  attachClickHandlerMono("pack_confort_mono");

  //BI :

  var bi2600W = document.getElementById("bi-2600W-2600W");
  if (bi2600W && bi2600W.checked) {
    updatePriceBiSplit(
      climBi1,
      climBi2,
      readyclim4,
      readyclim6,
      connecteur,
      moduleWifiProduct,
      serenityPackBi,
      annualMaintenanceBi,
      premiumWarranty
    );
  }
  function attachCheckedHandlerBi(elementId) {
    document.getElementById(elementId).onclick = function () {
      updatePriceBiSplit(
        climBi1,
        climBi2,
        readyclim4,
        readyclim6,
        connecteur,
        moduleWifiProduct,
        serenityPackBi,
        annualMaintenanceBi,
        premiumWarranty
      );
    };
  }

  function attachClickHandlerBi(elementName) {
    var elements = document.getElementsByName(elementName);
    for (var element of elements) {
      element.addEventListener("click", function () {
        updatePriceBiSplit(
          climBi1,
          climBi2,
          readyclim4,
          readyclim6,
          connecteur,
          moduleWifiProduct,
          serenityPackBi,
          annualMaintenanceBi,
          premiumWarranty
        );
      });
    }
  }

  attachCheckedHandlerBi("bi-2600W-2600W");
  attachClickHandlerBi("rc1Select");
  attachClickHandlerBi("rc2Select");
  attachClickHandlerBi("mwSelect");
  attachClickHandlerBi("pack_confort_bi");

  //TRI :

  var tri2600W = document.getElementById("tri-2600W-2600W-2600W");
  if (tri2600W && tri2600W.checked) {
    updatePriceTrisplit(
      climTri1,
      readyclim4,
      readyclim6,
      connecteur,
      moduleWifiProduct,
      serenityPackTri,
      annualMaintenanceTri,
      premiumWarranty
    );
  }

  function attachCheckedHandlerTri(elementId) {
    var element = document.getElementById(elementId);
    if (element) {
      element.onclick = function () {
        updatePriceTrisplit(
          climTri1,
          readyclim4,
          readyclim6,
          connecteur,
          moduleWifiProduct,
          serenityPackTri,
          annualMaintenanceTri,
          premiumWarranty
        );
      };
    } else {
      console.error(`Element with ID ${elementId} not found`);
    }
  }

  function attachClickHandlerTri(elementName) {
    var elements = document.getElementsByName(elementName);
    for (var element of elements) {
      element.addEventListener("click", function () {
        updatePriceTrisplit(
          climTri1,
          readyclim4,
          readyclim6,
          connecteur,
          moduleWifiProduct,
          serenityPackTri,
          annualMaintenanceTri,
          premiumWarranty
        );
      });
    }
  }

  attachCheckedHandlerTri("tri-2600W-2600W-2600W");
  attachClickHandlerTri("rc1Select-trisplit");
  attachClickHandlerTri("rc2Select-trisplit");
  attachClickHandlerTri("rc3Select-trisplit");
  attachClickHandlerTri("mwSelect-trisplit");
  attachClickHandlerTri("pack_confort_tri");

  //QUADRI :
  var quadri2600W = document.getElementById("quadri-2600W-2600W-2600W-2600W");
  if (quadri2600W && quadri2600W.checked) {
    updatePriceQuadriSplit(
      climQuadri1,
      readyclim4,
      readyclim6,
      connecteur,
      moduleWifiProduct,
      serenityPackQuadri,
      annualMaintenanceQuadri,
      premiumWarranty
    );
  }

  function attachCheckedHandlerQuadri(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.onclick = function () {
        updatePriceQuadriSplit(
          climQuadri1,
          readyclim4,
          readyclim6,
          connecteur,
          moduleWifiProduct,
          serenityPackQuadri,
          annualMaintenanceQuadri,
          premiumWarranty
        );
      };
    } else {
      console.error(`Element with ID '${elementId}' not found`);
    }
  }

  function attachClickHandlerQuadri(elementName) {
    var elements = document.getElementsByName(elementName);
    for (var element of elements) {
      element.addEventListener("click", function () {
        updatePriceQuadriSplit(
          climQuadri1,
          readyclim4,
          readyclim6,
          connecteur,
          moduleWifiProduct,
          serenityPackQuadri,
          annualMaintenanceQuadri,
          premiumWarranty
        );
      });
    }
  }
  attachCheckedHandlerQuadri("quadri-2600W-2600W-2600W-2600W");
  attachClickHandlerQuadri("rc1Select-quadrisplit");
  attachClickHandlerQuadri("rc2Select-quadrisplit");
  attachClickHandlerQuadri("rc3Select-quadrisplit");
  attachClickHandlerQuadri("rc4Select-quadrisplit");
  attachClickHandlerQuadri("mwSelect-quadrisplit");
  attachClickHandlerQuadri("pack_confort_quadri");

  /**
   * MANAGEMENT ADD TO BASKET AIR CONDITIONERS AND ACCESSORIES
   */

  let formData = { items: [] };

  //For push items to google dataLayer
  // function pushToDataLayer(product, quantity, url) {
  //   window.dataLayer.push({
  //     event: "product_added_to_cart",
  //     ecommerce: {
  //       currency: "EUR",
  //       value: product.price * quantity,
  //       items: [
  //         {
  //           item_id: product.id,
  //           item_variant: product.id,
  //           item_variant_id: product.id,
  //           item_variant_title: product.title,
  //           item_name: product.name,
  //           item_product_id: product.id,
  //           item_product_title: product.name,
  //           sku: product.sku,
  //           discount: 0,
  //           price: product.price,
  //           item_brand: product.brand,
  //           item_category: product.category,
  //           quantity: quantity,
  //           coupon: "",
  //           url: url,
  //         },
  //       ],
  //     },
  //   });
  // }

  //Function for adding the items to the cart
  //MONO :
  async function addToCartMono() {
    var radiosClims = document.getElementsByName("watt-clim-mono");

    for (var radio of radiosClims) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "mono-2500W") {
          formData.items.push({
            id: climMono1.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climMono1,
          //   1,
          //   "https://www.airton.shop/products/climatiseur-fixe-reversible"
          // );
        } else if (id == "mono-3400W") {
          formData.items.push({
            id: climMono2.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climMono2,
          //   1,
          //   "https://www.airton.shop/products/climatiseur-fixe-reversible"
          // );
        } else if (id == "mono-5270W") {
          formData.items.push({
            id: climMono3.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climMono3,
          //   1,
          //   "https://www.airton.shop/products/climatiseur-fixe-reversible"
          // );
        }
      }
    }

    var radiosRcSelectMono = document.getElementsByName("rcSelect-Mono");

    for (var radio of radiosRcSelectMono) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (id == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (id == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (id == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (id == "12") {
          formData.items.push(
            { id: readyclim6.id, quantity: 2 },
            { id: connecteur.id, quantity: 1 }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idRcSelectMono5270 = document.getElementsByName("rcSelect-Mono-5270");

    for (var radio of idRcSelectMono5270) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "4-5270") {
          formData.items.push({
            id: readyclimAutre4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclimAutre4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (id == "6-5270") {
          formData.items.push({
            id: readyclimAutre6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclimAutre6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclimAutre4,
          //   2,
          //   "https://www.airton.shop/products/liaison-frigorifique-readyclim-de-4m-1-4-3-8-r32"
          // );
          // pushToDataLayer(
          //   connecteurAutre,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (id == "8-5270") {
          formData.items.push(
            { id: readyclimAutre4.id, quantity: 2 },
            { id: connecteurAutre.id, quantity: 1 }
          );
        } else if (id == "10-5270") {
          formData.items.push(
            { id: readyclimAutre4.id, quantity: 1 },
            { id: readyclimAutre6.id, quantity: 1 },
            { id: connecteurAutre.id, quantity: 1 }
          );
          // pushToDataLayer(
          //   readyclimAutre4,
          //   1,
          //   "https://www.airton.shop/products/liaison-frigorifique-readyclim-de-4m-1-4-3-8-r32"
          // );
          // pushToDataLayer(
          //   readyclimAutre6,
          //   1,
          //   "https://www.airton.shop/products/liaison-frigorifique-readyclim-de-6m-1-4-3-8-r32"
          // );
          // pushToDataLayer(
          //   connecteurAutre,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (id == "12-5270") {
          formData.items.push(
            { id: readyclimAutre6.id, quantity: 2 },
            { id: connecteurAutre.id, quantity: 1 }
          );
          // pushToDataLayer(
          //   readyclimAutre6,
          //   2,
          //   "https://www.airton.shop/products/liaison-frigorifique-readyclim-de-6m-1-4-3-8-r32"
          // );
          // pushToDataLayer(
          //   connecteurAutre,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idWifiMono = document.getElementsByName("wifiMono");

    for (var radio of idWifiMono) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "mw1") {
          formData.items.push({
            id: moduleWifiProduct.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   moduleWifiProduct,
          //   1,
          //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
          // );
        }
      }
    }

    //Comfort pack selection
    var idComfortPackMono = document.getElementsByName("pack_confort_mono");

    for (var select of idComfortPackMono) {
      if (select.checked) {
        if (select.value == "pack_serenity_mono") {
          formData.items.push({
            id: serenityPackMono.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   serenityPackMono,
          //   1,
          //   "https://www.airton.shop/products/pack-serenite-1"
          // );
        } else if (select.value == "entretien_annuel_mono") {
          formData.items.push({
            id: annualMaintenanceMono.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   annualMaintenanceMono,
          //   1,
          //   "https://www.airton.shop/products/contrat-entretien-annuel"
          // );
        } else if (select.value == "garantie_premium_mono") {
          formData.items.push({
            id: premiumWarranty.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   premiumWarranty,
          //   1,
          //   "https://www.airton.shop/products/garantie-premium-annuelle"
          // );
        }
      }
    }

    // ADD to cart with selected items
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response.status);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    console.log("Add to cart mono: " + JSON.stringify(formData));

    // We introduce a delay before calling updateGlobalCartDrawer
    await new Promise((resolve) => setTimeout(resolve, 1000));
    await updateGlobalCartDrawer(formData);
    await openDrawer();

    formData = { items: [] };
  }

  // Bisplit :
  async function addToCartBi() {
    var radiosClimsBi = document.getElementsByName("watt-clim-bi");

    for (var radio of radiosClimsBi) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "bi-2600W-2600W") {
          formData.items.push({
            id: climBi1.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climBi1,
          //   1,
          //   "https://airton.shop/products/pompe-a-chaleur-climatiseur-bisplit"
          // );
        } else if (id == "bi-2600W-3400W") {
          formData.items.push({
            id: climBi2.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climBi2,
          //   1,
          //   "https://airton.shop/products/pompe-a-chaleur-climatiseur-bisplit"
          // );
        }
      }
    }

    var idRc1Select = document.getElementsByName("rc1Select");

    for (var select of idRc1Select) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idRc2Select = document.getElementsByName("rc2Select");

    for (var select of idRc2Select) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          //   pushToDataLayer(
          //     readyclim4,
          //     1,
          //     "https://www.airton.shop/products/liaison-ready-clim"
          //   );
          // } else if (select.value == "6") {
          //   formData.items.push({
          //     id: readyclim6.id,
          //     quantity: 1,
          //   });
          //   pushToDataLayer(
          //     readyclim6,
          //     1,
          //     "https://www.airton.shop/products/liaison-ready-clim"
          //   );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var mwSelect = document.getElementsByName("mwSelect");

    for (var select of mwSelect) {
      if (select.checked) {
        if (select.value == "1") {
          formData.items.push({
            id: moduleWifiProduct.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   moduleWifiProduct,
          //   1,
          //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
          // );
        } else if (select.value == "2") {
          formData.items.push({
            id: moduleWifiProduct.id,
            quantity: 2,
          });
          // pushToDataLayer(
          //   moduleWifiProduct,
          //   2,
          //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
          // );
        }
      }
    }

    var idComfortPackBi = document.getElementsByName("pack_confort_bi");

    for (var select of idComfortPackBi) {
      if (select.checked) {
        if (select.value == "pack_serenity_bi") {
          formData.items.push({
            id: serenityPackBi.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   serenityPackBi,
          //   1,
          //   "https://www.airton.shop/products/pack-serenite-1"
          // );
        } else if (select.value == "entretien_annuel_bi") {
          formData.items.push({
            id: annualMaintenanceBi.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   annualMaintenanceBi,
          //   1,
          //   "https://www.airton.shop/products/contrat-entretien-annuel"
          // );
        } else if (select.value == "garantie_premium_bi") {
          formData.items.push({
            id: premiumWarranty.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   premiumWarranty,
          //   1,
          //   "https://www.airton.shop/products/garantie-premium-annuelle"
          // );
        }
      }
    }

    // ADD ro cart with selected items
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response.status);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    //console.log("Add to cart bisplit: " + JSON.stringify(formData));

    await new Promise((resolve) => setTimeout(resolve, 1000));
    await updateGlobalCartDrawer(formData);
    await openDrawer();

    formData = {
      items: [],
    };
  }

  //Trisplit :
  async function addToCartTri() {
    var radiosClimsTri = document.getElementsByName("watt-clim-tri");

    for (var radio of radiosClimsTri) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "tri-2600W-2600W-2600W") {
          formData.items.push({
            id: climTri1.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climTri1,
          //   1,
          //   "https://www.airton.shop/products/climatiseur-fixe-reversible"
          // );
        }
      }
    }

    var idRc1Select3 = document.getElementsByName("rc1Select-trisplit");

    for (var select of idRc1Select3) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          pushToDataLayer(
            readyclim4,
            1,
            "https://www.airton.shop/products/liaison-ready-clim"
          );
        } else if (select.value == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idRc2Select3 = document.getElementsByName("rc2Select-trisplit");

    for (var select of idRc2Select3) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          //   pushToDataLayer(
          //     readyclim4,
          //     1,
          //     "https://www.airton.shop/products/liaison-ready-clim"
          //   );
          // } else if (select.value == "6") {
          //   formData.items.push({
          //     id: readyclim6.id,
          //     quantity: 1,
          //   });
          //   pushToDataLayer(
          //     readyclim6,
          //     1,
          //     "https://www.airton.shop/products/liaison-ready-clim"
          //   );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idRc3Select3 = document.getElementsByName("rc3Select-trisplit");

    for (var select of idRc3Select3) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var mwSelectTrisplit = document.getElementsByName("mwSelect-trisplit");

    for (var select of mwSelectTrisplit) {
      if (select.checked) {
        if (select.value == "1") {
          formData.items.push({
            id: moduleWifiProduct.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   moduleWifiProduct,
          //   1,
          //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
          // );
        } else if (select.value == "2") {
          formData.items.push({
            id: moduleWifiProduct.id,
            quantity: 2,
          });
          // pushToDataLayer(
          //   moduleWifiProduct,
          //   2,
          //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
          // );
        } else if (select.value == "3") {
          formData.items.push({
            id: moduleWifiProduct.id,
            quantity: 3,
          });
          // pushToDataLayer(
          //   moduleWifiProduct,
          //   3,
          //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
          // );
        }
      }
    }

    var idComfortPackTri = document.getElementsByName("pack_confort_tri");

    for (var select of idComfortPackTri) {
      if (select.checked) {
        if (select.value == "pack_serenity_tri") {
          formData.items.push({
            id: serenityPackTri.id,
            quantity: 1,
          });
          pushToDataLayer(
            serenityPackTri,
            1,
            "https://www.airton.shop/products/pack-serenite-1"
          );
        } else if (select.value == "entretien_annuel_tri") {
          formData.items.push({
            id: annualMaintenanceTri.id,
            quantity: 1,
          });
          pushToDataLayer(
            annualMaintenanceTri,
            1,
            "https://www.airton.shop/products/contrat-entretien-annuel"
          );
        } else if (select.value == "garantie_premium_tri") {
          formData.items.push({
            id: premiumWarranty.id,
            quantity: 1,
          });
          pushToDataLayer(
            premiumWarranty,
            1,
            "https://www.airton.shop/products/garantie-premium-annuelle"
          );
        }
      }
    }

    //console.log("Add to cart trisplit 1 : " + JSON.stringify(formData));

    // ADD to cart with selected items
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log(response.status);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    await new Promise((resolve) => setTimeout(resolve, 1000));
    updateGlobalCartDrawer(formData);
    await openDrawer();

    formData = {
      items: [],
    };
  }

  //Quadrisplit :
  async function addToCartQuadri() {
    var radiosClimsQuadri = document.getElementsByName("watt-clim-quadri");

    for (var radio of radiosClimsQuadri) {
      if (radio.checked) {
        var id = radio.value;

        if (id == "quadri-2600W-2600W-2600W-2600W") {
          formData.items.push({
            id: climQuadri1.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   climQuadri1,
          //   1,
          //   "https://airton.shop/products/pompe-a-chaleur-climatiseur-quadri"
          // );
        }
      }
    }

    var idRc1Select3 = document.getElementsByName("rc1Select-quadrisplit");

    for (var select of idRc1Select3) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-frigorifique-readyclim-de-4m-1-4-3-8-r32"
          // );
        } else if (select.value == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );

          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idRc2Select3 = document.getElementsByName("rc2Select-quadrisplit");

    for (var select of idRc2Select3) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim6,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        }
      }
    }

    var idRc3Select3 = document.getElementsByName("rc3Select-quadrisplit");

    for (var select of idRc3Select3) {
      if (select.checked) {
        if (select.value == "4") {
          formData.items.push({
            id: readyclim4.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "6") {
          formData.items.push({
            id: readyclim6.id,
            quantity: 1,
          });
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
        } else if (select.value == "8") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   2,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "10") {
          formData.items.push(
            {
              id: readyclim4.id,
              quantity: 1,
            },
            {
              id: readyclim6.id,
              quantity: 1,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          // pushToDataLayer(
          //   readyclim4,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   readyclim6,
          //   1,
          //   "https://www.airton.shop/products/liaison-ready-clim"
          // );
          // pushToDataLayer(
          //   connecteur,
          //   1,
          //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          // );
        } else if (select.value == "12") {
          formData.items.push(
            {
              id: readyclim6.id,
              quantity: 2,
            },
            {
              id: connecteur.id,
              quantity: 1,
            }
          );
          //   pushToDataLayer(
          //     readyclim6,
          //     2,
          //     "https://www.airton.shop/products/liaison-ready-clim"
          //   );
          //   pushToDataLayer(
          //     connecteur,
          //     1,
          //     "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
          //   );
          // }
        }
      }

      var idRc4Select4 = document.getElementsByName("rc4Select-quadrisplit");

      for (var select of idRc4Select4) {
        if (select.checked) {
          if (select.value == "4") {
            formData.items.push({
              id: readyclim4.id,
              quantity: 1,
            });
            // pushToDataLayer(
            //   readyclim4,
            //   1,
            //   "https://www.airton.shop/products/liaison-ready-clim"
            // );
          } else if (select.value == "6") {
            formData.items.push({
              id: readyclim6.id,
              quantity: 1,
            });
            // pushToDataLayer(
            //   readyclim6,
            //   1,
            //   "https://www.airton.shop/products/liaison-ready-clim"
            // );
          } else if (select.value == "8") {
            formData.items.push(
              {
                id: readyclim4.id,
                quantity: 2,
              },
              {
                id: connecteur.id,
                quantity: 1,
              }
            );
            // pushToDataLayer(
            //   readyclim4,
            //   2,
            //   "https://www.airton.shop/products/liaison-ready-clim"
            // );
            // pushToDataLayer(
            //   connecteur,
            //   1,
            //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
            // );
          } else if (select.value == "10") {
            formData.items.push(
              {
                id: readyclim4.id,
                quantity: 1,
              },
              {
                id: readyclim6.id,
                quantity: 1,
              },
              {
                id: connecteur.id,
                quantity: 1,
              }
            );
            // pushToDataLayer(
            //   readyclim4,
            //   1,
            //   "https://www.airton.shop/products/liaison-ready-clim"
            // );
            // pushToDataLayer(
            //   readyclim6,
            //   1,
            //   "https://www.airton.shop/products/liaison-ready-clim"
            // );
            // pushToDataLayer(
            //   connecteur,
            //   1,
            //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
            // );
          } else if (select.value == "12") {
            formData.items.push(
              {
                id: readyclim6.id,
                quantity: 2,
              },
              {
                id: connecteur.id,
                quantity: 1,
              }
            );
            // pushToDataLayer(
            //   readyclim6,
            //   2,
            //   "https://www.airton.shop/products/liaison-ready-clim"
            // );
            // pushToDataLayer(
            //   connecteur,
            //   1,
            //   "https://www.airton.shop/products/airton-connecteur-r32-union-raccord-inter-liaison-readyclim-1-4-3-8"
            // );
          }
        }
      }

      var mwSelectQuadrisplit = document.getElementsByName(
        "mwSelect-quadrisplit"
      );

      for (var select of mwSelectQuadrisplit) {
        if (select.checked) {
          if (select.value == "1") {
            formData.items.push({
              id: moduleWifiProduct.id,
              quantity: 1,
            });
            // pushToDataLayer(
            //   moduleWifiProduct,
            //   1,
            //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
            // );
          } else if (select.value == "2") {
            formData.items.push({
              id: moduleWifiProduct.id,
              quantity: 2,
            });
            // pushToDataLayer(
            //   moduleWifiProduct,
            //   2,
            //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
            // );
          } else if (select.value == "3") {
            formData.items.push({
              id: moduleWifiProduct.id,
              quantity: 3,
            });
            // pushToDataLayer(
            //   moduleWifiProduct,
            //   3,
            //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
            // );
          } else if (select.value == "4") {
            formData.items.push({
              id: moduleWifiProduct.id,
              quantity: 4,
            });
            // pushToDataLayer(
            //   moduleWifiProduct,
            //   4,
            //   "https://www.airton.shop/products/kit-module-wifi-pour-climatiseurs-airton-en-wifi-ready"
            // );
          }
        }
      }

      var idComfortPackQuadri = document.getElementsByName(
        "pack_confort_quadri"
      );

      for (var select of idComfortPackQuadri) {
        if (select.checked) {
          if (select.value == "pack_serenity_quadri") {
            formData.items.push({
              id: serenityPackQuadri.id,
              quantity: 1,
            });
            // pushToDataLayer(
            //   serenityPackQuadri,
            //   1,
            //   "https://www.airton.shop/products/pack-serenite-1"
            // );
          } else if (select.value == "entretien_annuel_quadri") {
            formData.items.push({
              id: annualMaintenanceQuadri.id,
              quantity: 1,
            });
            // pushToDataLayer(
            //   annualMaintenanceQuadri,
            //   1,
            //   "https://www.airton.shop/products/contrat-entretien-annuel"
            // );
          } else if (select.value == "garantie_premium_quadri") {
            formData.items.push({
              id: premiumWarranty.id,
              quantity: 1,
            });
            // pushToDataLayer(
            //   premiumWarranty,
            //   1,
            //   "https://www.airton.shop/products/garantie-premium-annuelle"
            // );
          }
        }
      }

      //console.log("Add to cart quadrisplit 1 : " + JSON.stringify(formData));

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          console.log(response.status);
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      await new Promise((resolve) => setTimeout(resolve, 1000));
      await updateGlobalCartDrawer(formData);
      await openDrawer();

      formData = {
        items: [],
      };
    }
  }

  /**
   * Add to cart button event listeners
   */
  const btnAddToCartMono = document.getElementById("add-to-cart-mono");
  if (btnAddToCartMono) {
    btnAddToCartMono.addEventListener("click", async () => {
      await addToCartMono();
    });
  } else {
    console.error("Element with ID 'add-to-cart-mono' not found");
  }

  // const btnAddToCartBi = document.getElementById("add-to-cart-bisplit");
  // if (btnAddToCartBi) {
  //   btnAddToCartBi.addEventListener("click", async () => {
  //     await addToCartBi();
  //   });
  // }

  // const btnAddToCartTri = document.getElementById("add-to-cart-trisplit");
  // if (btnAddToCartTri) {
  //   btnAddToCartTri.addEventListener("click", async () => {
  //     await addToCartTri();
  //   });
  // }

  // const btnAddToCartQuadri = document.getElementById("add-to-cart-quadrisplit");
  // if (btnAddToCartQuadri) {
  //   btnAddToCartQuadri.addEventListener("click", async () => {
  //     await addToCartQuadri();
  //   });
  // }

  // }
});

/**
 * MANGEMENT OF QUERY PARAMATERS
 */
document.addEventListener("DOMContentLoaded", function () {
  const searchParams = new URLSearchParams(window.location.search);

  if (!searchParams.toString()) return;

  const mappings = {
    splits: {
      1: "split-mono",
      2: "split-bi",
      3: "split-tri",
      4: "split-quadri",
      default: "split-mono",
    },
    puissance: {
      "2500W": "mono-2500W",
      "3400W": "mono-3400W",
      "5270W": "mono-5270W",
      "2600W-2600W": "bi-2600W-2600W",
      "2600W-3400W": "bi-2600W-3400W",
      "2600W-2600W-3500W": "tri-2600W-2600W-2600W",
      "2600W-2600W-2600W-3500W": "quadri-2600W-2600W-2600W-2600W",
    },
    readyclim: {
      0: "rc0",
      4: "rc4",
      6: "rc6",
      8: "rc8",
      10: "rc10",
      12: "rc12",
      "4-5270": "rc4-5270",
      "6-5270": "rc6-5270",
      "8-5270": "rc8-5270",
      "10-5270": "rc10-5270",
      "12-5270": "rc12-5270",
    },
    wifi: {
      0: "wifiMono0",
      1: "wifiMono1",
    },
  };

  function clickElementByValueOrId(param, type) {
    const value = searchParams.get(param);
    const elementId = mappings[type]?.[value] || mappings[type]?.default;
    if (elementId) {
      document
        .querySelector(`[id="${elementId}"], [value="${elementId}"]`)
        ?.click();
    }
  }

  clickElementByValueOrId("splits", "splits");
  clickElementByValueOrId("puissance", "puissance");
  clickElementByValueOrId("readyclim", "readyclim");
  clickElementByValueOrId("wifi", "wifi");
});
